<div class="flex">
  <ng-container *ngIf="isArrangeClassBtn">
    <a class="text-green-600" nzTooltipTitle="Xếp lớp" nzTooltipPlacement="top" nz-tooltip
      (click)="arrangeClassEvent($event)">
      <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
    </a>
  </ng-container>
  <ng-container *ngIf="isPasswordRecoveryBtn">
    <a nzTooltipTitle="Phục hồi mật khẩu" nzTooltipPlacement="top" nz-tooltip (click)="passwordRecoveryEvent($event)">
      <i nz-icon nzType="redo" nzTheme="outline"></i>
    </a>
  </ng-container>
  <ng-container *ngIf="isInfoBtn">
    <a class="text-green-600" nzTooltipTitle="Thông tin" nzTooltipPlacement="top" nz-tooltip
      (click)="infoEvent($event)">
      <i nz-icon nzType="info-circle" nzTheme="outline"></i>
    </a>
  </ng-container>
  <ng-container *ngIf="isEditBtn">
    <a class="text-blue-600 ml-1" [nzTooltipTitle]="title_edit" nzTooltipPlacement="top" nz-tooltip (click)="editEvent($event)">
      <i nz-icon [nzType]="icon_edit" nzTheme="outline"></i>
    </a>
  </ng-container>
  <ng-container *ngIf="isDeleteBtn">
    <a class="text-red-600 ml-1" nzTooltipTitle="xóa" nzTooltipPlacement="top" nz-tooltip (click)="deleteEvent($event)">
      <i nz-icon [nzType]="icon_delete" nzTheme="outline"></i>
    </a>
  </ng-container>
</div>
